/* FalcX footer (r7): sections/falcx-footer-main.liquid.
   - Link columns are <details>: open from 750 px up, closed on phones (an inline script in the section closes them
     before they paint; this keeps them right when the window changes size).
   - Saved vehicle: ticks its Falcon hub and turns the "Not sure which one you have?" line into
     "Shopping for your BA–BF Ute / Parts for your car". Reads window.FalcxVehicle (assets/falcx-finder.js) and follows
     its falcx:vehicle-change event. Both lines have a fixed height, so nothing moves.
   - Back to top: smooth unless reduced motion; from the keyboard, focus goes to the skip link (first stop on the page).
   Without JavaScript: every column open, the plain fitment-guide line, "Back to top" is a normal link to the main content. */
(function (root) {
  'use strict';

  /* Pure part, exported for tests. saved = FalcxVehicle.getSaved() ({key, label, series, body, url}) or null. */
  function carLine(saved, destination, fallback) {
    if (!saved || !saved.label || !saved.url) return {mine: null, text: fallback.text, label: fallback.label, href: fallback.href, html: false};
    var href = typeof destination === 'function' ? destination(saved) : saved.url + '?series=' + encodeURIComponent(saved.series) + '&body=' + encodeURIComponent(saved.body);
    return {mine: saved.url, text: 'Shopping for your ' + saved.label, label: 'Parts for your car', href: href, html: true};
  }
  function hubPath(href) {
    return String(href || '').replace(/^https?:\/\/[^/]+/i, '').split(/[?#]/)[0].replace(/\/+$/, '');
  }

  if (typeof module !== 'undefined' && module.exports) { module.exports = {carLine: carLine, hubPath: hubPath}; return; }

  var doc = root.document;
  var phone = root.matchMedia ? root.matchMedia('(max-width: 749px)') : null;

  /* closeOnPhone is false on load: the inline script already closed them, and a column opened since stays open. */
  function setAccordions(footer, closeOnPhone) {
    var isPhone = phone ? phone.matches : false;
    footer.querySelectorAll('[data-fxf-acc]').forEach(function (d) {
      if (!isPhone) d.open = true;
      else if (closeOnPhone) d.open = false;
    });
  }

  function paintCar(footer) {
    var box = footer.querySelector('[data-fxf-mycar]');
    if (!box) return;
    var text = box.querySelector('[data-fxf-mycar-text]');
    var link = box.querySelector('[data-fxf-mycar-link]');
    var label = box.querySelector('[data-fxf-mycar-label]');
    if (!box.dataset.fxfDefault) box.dataset.fxfDefault = JSON.stringify({text: text.textContent, label: label.textContent, href: link.getAttribute('href')});
    var fallback = JSON.parse(box.dataset.fxfDefault);
    var api = root.FalcxVehicle;
    var saved = api && api.getSaved ? api.getSaved() : null;
    var line = carLine(saved, api && api.destination, fallback);
    if (line.html) {
      text.textContent = 'Shopping for your ';
      var strong = doc.createElement('strong');
      strong.textContent = saved.label;
      text.appendChild(strong);
    } else {
      text.textContent = line.text;
    }
    text.title = line.html ? line.text : '';
    label.textContent = line.label;
    link.setAttribute('href', line.href);
    var mine = line.mine ? hubPath(line.mine) : null;
    footer.querySelectorAll('[data-fxf-hub]').forEach(function (a) {
      var on = !!mine && hubPath(a.getAttribute('data-fxf-hub')) === mine;
      a.classList.toggle('is-mine', on);
      var mark = a.querySelector('[data-fxf-mine]');
      if (mark) mark.hidden = !on;
    });
  }

  function scrollerOf(el) {
    for (var node = el.parentElement; node && node !== doc.body && node !== doc.documentElement; node = node.parentElement) {
      var y = root.getComputedStyle(node).overflowY;
      if ((y === 'auto' || y === 'scroll') && node.scrollHeight > node.clientHeight) return node;
    }
    return null;
  }

  function init() {
    doc.querySelectorAll('[data-falcx-footer]').forEach(function (footer) {
      setAccordions(footer, false);
      paintCar(footer);
      if (footer.dataset.fxfBound) return;
      footer.dataset.fxfBound = '1';
      footer.addEventListener('click', function (e) {
        var top = e.target.closest && e.target.closest('[data-fxf-top]');
        if (!top) return;
        e.preventDefault();
        var reduce = root.matchMedia && root.matchMedia('(prefers-reduced-motion: reduce)').matches;
        /* Horizon can make .page-wrapper the scroller instead of the window: scroll whichever holds the footer. */
        var scroller = scrollerOf(footer);
        (scroller || root).scrollTo({top: 0, left: 0, behavior: reduce ? 'auto' : 'smooth'});
        /* Keyboard only (a click from a key press has detail 0): a mouse user keeps no stray focus ring. */
        var first = e.detail === 0 ? doc.querySelector('.skip-to-content-link, a[href="#MainContent"]') || doc.body : null;
        if (first) {
          if (first === doc.body && !first.hasAttribute('tabindex')) first.setAttribute('tabindex', '-1');
          try { first.focus({preventScroll: true}); } catch (err) { first.focus(); }
        }
      });
    });
  }

  /* Crossing 750 px: open everything (desktop) or close everything (phone). Listens to resize as well, because not every
     browser or emulator fires the media query's change event. */
  if (phone) {
    var wasPhone = phone.matches;
    var onChange = function () {
      if (phone.matches === wasPhone) return;
      wasPhone = phone.matches;
      doc.querySelectorAll('[data-falcx-footer]').forEach(function (f) { setAccordions(f, true); });
    };
    if (phone.addEventListener) phone.addEventListener('change', onChange); else if (phone.addListener) phone.addListener(onChange);
    root.addEventListener('resize', onChange, {passive: true});
  }
  doc.addEventListener('falcx:vehicle-change', function () { doc.querySelectorAll('[data-falcx-footer]').forEach(paintCar); });
  doc.addEventListener('shopify:section:load', init);
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', init, {once: true}); else init();
})(typeof window !== 'undefined' ? window : this);
